import React from 'react'
import filter from 'lodash/filter'
import StaticQuestionSlide from '../../slides/StaticQuestionSlide'
import { Spring, animated, interpolate, config } from 'react-spring'
import Icon from '../../misc/Icons'
import SyncLiveViewPlayerControlBarReview from './SyncLiveViewPlayerControlBarReview'

class SyncLiveViewPlayerControlBar extends React.Component{

	
	render(){		

		
			const {questionStage,currentSection,onlineStudentCount,classSafeMode,poll,showGraph,isSet,narrowControlBarView,revealAnswer,currentQuestionIndex,isSurvey,questionsAndPollsList,playQuestionInSet}=this.props
			let totalStudentCount=0
			let totalAnsweredStudentCount=0
			if(questionStage==='scan' && currentSection){
				const students=filter(currentSection.students,{archived:false})
				totalStudentCount=students.length
				if(poll && poll.responsesByCard){
					totalAnsweredStudentCount=Object.keys(poll.responsesByCard).length
				}
				
			}

			let controlBarWidth
			let isNarrowView = false

			if(this.props.slideWidth < 700){
				controlBarWidth = '100%'
			}
			else{
				controlBarWidth = `${this.props.slideWidth}px`
			}

			const scanProgressBarWidth = Math.min((totalAnsweredStudentCount / onlineStudentCount), 1)


			const fadeOutQuestionControlButtons = (questionStage === 'review') && !isSurvey && !revealAnswer
			const fadeInQuestionControlButtons = (questionStage === 'review') && revealAnswer
			// when in review, fade out has not revealed answer and is a survey


			return(				
				<div className={'syncLiveView-player-main-controlBarContainer ' + (narrowControlBarView ? 'syncLiveView-player-main-controlBarContainer--narrow':'')}>			
					<div style={{maxWidth: `${controlBarWidth}`}} className='syncLiveView-player-main-controlBar'>
												
						{isSet &&
							<button disabled={currentQuestionIndex===0 || questionStage === 'scan'} onClick={()=>{playQuestionInSet(questionsAndPollsList[currentQuestionIndex-1])}} className={'syncLiveView-player-main-controlBar-questionControlBtn ' + (fadeOutQuestionControlButtons ? ' syncLiveView-player-main-controlBar-questionControlBtn--fade ' : '') + (fadeInQuestionControlButtons ? ' syncLiveView-player-main-controlBar-questionControlBtn--fadeIn ' : '')}>							
								<div className='syncLiveView-player-main-controlBar-questionControlBtn-contents'>
									<svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">    
										<path d="M10.2857273,14.72 L28.6206364,1.52266667 C30.0766364,0.501333333 31.2704545,1.25066667 31.2704545,3.18933333 L31.2704545,28.8133333 C31.2704545,30.7466667 30.0766364,31.496 28.6206364,30.48 L10.2857273,17.2773333 C10.2857273,17.2773333 9.57554545,16.7466667 9.57554545,16.0026667 C9.57554545,15.256 10.2857273,14.72 10.2857273,14.72 Z M5.97708187,0.00063723259 L3.27045455,0 C1.86281818,0 0.725,0.128 0.725,1.6 L0.725,30.4 C0.725,31.872 1.86281818,32 3.27045455,32 L5.81590909,32 C7.22354545,32 8.36136364,31.872 8.36136364,30.4 L8.36136364,1.6 C8.36136364,0.184615385 7.30938677,0.0118343195 5.97708187,0.00063723259 L5.97708187,0.00063723259 Z" fillRule="nonzero"></path>    
									</svg>
								</div>
								<div className='syncLiveView-player-main-controlBar-questionControlBtn-keyboardTooltip'>
									Shift<span className='syncLiveView-player-main-controlBar-questionControlBtn-keyboardTooltip-lighten'>&nbsp;+</span> 
									<Icon name='key--arrowLeft'/>
								</div>
							</button>
						}
						

						<div className='syncLiveView-player-main-controlBar-center'>													
		            
                  <button onClick={this.props.toggleScanning} className={'syncLiveView-player-main-controlBar-scanBtn syncLiveView-player-main-controlBar-scanBtn--ask ' + (questionStage === 'ask' ? ' syncLiveView-player-main-controlBar-scanBtn--ask--show ' : ' syncLiveView-player-main-controlBar-scanBtn--ask--hide ')}>
										<div className='syncLiveView-player-main-controlBar-scanBtn-primary'>
											Start Accepting Answers
										</div>
										<div className='syncLiveView-player-main-controlBar-scanBtn-secondary'>
											Press <b>ENTER</b> key
										</div>
									</button>		                  
		            
                  <button onClick={this.props.toggleScanning}  className={'syncLiveView-player-main-controlBar-scanBtn syncLiveView-player-main-controlBar-scanBtn--scan'  + (questionStage === 'scan' ? ' syncLiveView-player-main-controlBar-scanBtn--scan--show ' : ' syncLiveView-player-main-controlBar-scanBtn--scan--hide ')}>
										<div className='syncLiveView-player-main-controlBar-scanBtn-primary'>
											Stop Taking Answers
										</div>
										<div className='syncLiveView-player-main-controlBar-scanBtn-secondary'>											
											{onlineStudentCount > 0 &&
												<div className='syncLiveView-player-main-controlBar-scanBtn--scan-graph'>
													<div style={{width: `${scanProgressBarWidth * 100}%`}} className='syncLiveView-player-main-controlBar-scanBtn--scan-graph-bar' />
													<div className='syncLiveView-player-main-controlBar-scanBtn--scan-graph-track' />
												</div>
											}
										</div>
									</button>                  
														

								<SyncLiveViewPlayerControlBarReview
									toggleScanning={this.props.toggleScanning}
									questionStage={questionStage}
									toggleShowCorrect={this.props.toggleShowCorrect}
									toggleShowGraph={this.props.toggleShowGraph}
									narrowControlBarView={narrowControlBarView}
									isSurvey={isSurvey}
									showGraph={showGraph}
									revealAnswer={revealAnswer}
									showCorrectSubmitLoading={this.props.showCorrectSubmitLoading}
									showGraphSubmitLoading={this.props.showGraphSubmitLoading}
								/>

									{/*
									<button disabled={this.state.showGraphButtonDisabled} onClick={this.handleToggleShowGraph} className={'syncLiveView-player-main-controlBar-showGraph ' + (showGraph ? 'syncLiveView-player-main-controlBar-showGraph--active':'syncLiveView-player-main-controlBar-showGraph--inactive') + (narrowControlBarView ? ' syncLiveView-player-main-controlBar-showGraph--narrow' : '')}>		
										{!showGraph &&
											<div className='syncLiveView-player-main-controlBar-showGraph-icon'>											
												<svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
	  											<path d="M30.0465637,11.7333333 C30.725816,11.7333333 30.9721294,11.8040576 31.2204539,11.936863 C31.4687784,12.0696684 31.6636649,12.2645549 31.7964703,12.5128795 C31.9292757,12.761204 32,13.0075173 32,13.6867697 L32,26.8465637 C32,27.525816 31.9292757,27.7721294 31.7964703,28.0204539 C31.6636649,28.2687784 31.4687784,28.4636649 31.2204539,28.5964703 C30.9721294,28.7292757 30.725816,28.8 30.0465637,28.8 L27.5534363,28.8 C26.874184,28.8 26.6278706,28.7292757 26.3795461,28.5964703 C26.1312216,28.4636649 25.9363351,28.2687784 25.8035297,28.0204539 C25.6707243,27.7721294 25.6,27.525816 25.6,26.8465637 L25.6,13.6867697 C25.6,13.0075173 25.6707243,12.761204 25.8035297,12.5128795 C25.9363351,12.2645549 26.1312216,12.0696684 26.3795461,11.936863 C26.6278706,11.8040576 26.874184,11.7333333 27.5534363,11.7333333 L30.0465637,11.7333333 Z M21.5132303,3.2 C22.1924827,3.2 22.438796,3.27072428 22.6871205,3.40352968 C22.9354451,3.53633508 23.1303316,3.73122162 23.263137,3.97954613 C23.3959424,4.22787065 23.4666667,4.47418397 23.4666667,5.15343634 L23.4666667,26.8465637 C23.4666667,27.525816 23.3959424,27.7721294 23.263137,28.0204539 C23.1303316,28.2687784 22.9354451,28.4636649 22.6871205,28.5964703 C22.438796,28.7292757 22.1924827,28.8 21.5132303,28.8 L19.020103,28.8 C18.3408506,28.8 18.0945373,28.7292757 17.8462128,28.5964703 C17.5978883,28.4636649 17.4030017,28.2687784 17.2701963,28.0204539 C17.1373909,27.7721294 17.0666667,27.525816 17.0666667,26.8465637 L17.0666667,5.15343634 C17.0666667,4.47418397 17.1373909,4.22787065 17.2701963,3.97954613 C17.4030017,3.73122162 17.5978883,3.53633508 17.8462128,3.40352968 C18.0945373,3.27072428 18.3408506,3.2 19.020103,3.2 L21.5132303,3.2 Z M12.979897,8.53333333 C13.6591494,8.53333333 13.9054627,8.60405761 14.1537872,8.73686301 C14.4021117,8.86966842 14.5969983,9.06455495 14.7298037,9.31287946 C14.8626091,9.56120398 14.9333333,9.8075173 14.9333333,10.4867697 L14.9333333,26.8465637 C14.9333333,27.525816 14.8626091,27.7721294 14.7298037,28.0204539 C14.5969983,28.2687784 14.4021117,28.4636649 14.1537872,28.5964703 C13.9054627,28.7292757 13.6591494,28.8 12.979897,28.8 L10.4867697,28.8 C9.8075173,28.8 9.56120398,28.7292757 9.31287946,28.5964703 C9.06455495,28.4636649 8.86966842,28.2687784 8.73686301,28.0204539 C8.60405761,27.7721294 8.53333333,27.525816 8.53333333,26.8465637 L8.53333333,10.4867697 C8.53333333,9.8075173 8.60405761,9.56120398 8.73686301,9.31287946 C8.86966842,9.06455495 9.06455495,8.86966842 9.31287946,8.73686301 C9.56120398,8.60405761 9.8075173,8.53333333 10.4867697,8.53333333 L12.979897,8.53333333 Z M4.44656366,17.0666667 C5.12581603,17.0666667 5.37212935,17.1373909 5.62045387,17.2701963 C5.86877838,17.4030017 6.06366492,17.5978883 6.19647032,17.8462128 C6.32927572,18.0945373 6.4,18.3408506 6.4,19.020103 L6.4,26.8465637 C6.4,27.525816 6.32927572,27.7721294 6.19647032,28.0204539 C6.06366492,28.2687784 5.86877838,28.4636649 5.62045387,28.5964703 C5.37212935,28.7292757 5.12581603,28.8 4.44656366,28.8 L1.95343634,28.8 C1.27418397,28.8 1.02787065,28.7292757 0.779546131,28.5964703 C0.531221616,28.4636649 0.336335083,28.2687784 0.203529679,28.0204539 C0.0707242752,27.7721294 0,27.525816 0,26.8465637 L0,19.020103 C0,18.3408506 0.0707242752,18.0945373 0.203529679,17.8462128 C0.336335083,17.5978883 0.531221616,17.4030017 0.779546131,17.2701963 C1.02787065,17.1373909 1.27418397,17.0666667 1.95343634,17.0666667 L4.44656366,17.0666667 Z"></path>    
												</svg>
											</div>
										}
										
										<div className='syncLiveView-player-main-controlBar-showGraph-label'>											
											{!classSafeMode && !narrowControlBarView &&
												<React.Fragment>
													{showGraph ? 'Hide Graph from Students' : 'Show Graph to Students'}
												</React.Fragment>
											}
											{(classSafeMode || narrowControlBarView) &&
												<React.Fragment>
													{showGraph ? 'Hide Graph' : 'Show Graph'}
												</React.Fragment>
											}											
											
										</div>
										<div className='syncLiveView-player-main-controlBar-showGraph-keyboardTooltip'>
											Shift<span className='syncLiveView-player-main-controlBar-showGraph-keyboardTooltip-lighten'>&nbsp;+&nbsp;</span>Space bar											
										</div>			
									</button>

									<button onClick={this.props.toggleScanning} className={'syncLiveView-player-main-controlBar-scanBtn syncLiveView-player-main-controlBar-scanBtn--review' + (isSurvey ? ' syncLiveView-player-main-controlBar-scanBtn--review--survey ':'')}>
										<Icon name='plus' />
										<div className='syncLiveView-player-main-controlBar-scanBtn--review-tooltip'>
											Reopen for Answers
										</div>
									</button>

									<button disabled={this.state.showCorrectButtonDisabled || isSurvey} onClick={this.handleToggleShowCorrect} className={'syncLiveView-player-main-controlBar-revealAnswer ' + (revealAnswer ? 'syncLiveView-player-main-controlBar-revealAnswer--active':'syncLiveView-player-main-controlBar-revealAnswer--inactive') + (isSurvey ? ' syncLiveView-player-main-controlBar-revealAnswer--surveyHide': '') + (narrowControlBarView ? ' syncLiveView-player-main-controlBar-revealAnswer--narrow ' : '')}>		
										{!revealAnswer &&
											<div className='syncLiveView-player-main-controlBar-revealAnswer-icon'>											
												<svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">    
													<path d="M16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 1.082166e-15,24.836556 0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 Z" id="Circle"></path>
													<path d="M21.4624495,9.54928754 L13.606,18.779 L10.2527505,15.585646 C9.70794298,15.0667357 8.84677078,15.1125051 8.35707964,15.687808 L7.62988403,16.5421377 C7.1626299,17.0910809 7.20152782,17.9345664 7.7260778,18.4341821 L12.9897105,23.4476094 C13.535372,23.967333 14.3976258,23.9159771 14.8882302,23.3396013 L24.3647465,12.2063251 C24.8379008,11.6504502 24.8001618,10.8120604 24.2737512,10.3106726 L23.3609693,9.44127953 C22.8153077,8.92155584 21.9530539,8.97291175 21.4624495,9.54928754 Z" id="Check"></path>   
												</svg>
											</div>
										}
										<div className='syncLiveView-player-main-controlBar-showGraph-label'>																						
											{!classSafeMode && !narrowControlBarView &&
											<React.Fragment>
													{revealAnswer ? 'Hide Answer from Students' : 'Reveal Answer to Students'}
												</React.Fragment>
											}
											{(classSafeMode || narrowControlBarView) &&
												<React.Fragment>
													{revealAnswer ? 'Hide Answer' : 'Reveal Answer'}
												</React.Fragment>
											}
										</div>				
										<div className='syncLiveView-player-main-controlBar-revealAnswer-keyboardTooltip'>
											Shift<span className='syncLiveView-player-main-controlBar-revealAnswer-keyboardTooltip-lighten'>&nbsp;+&nbsp;</span>Enter											
										</div>
									</button>
								*/}

								
							
						</div>						

						
						{isSet &&
							<button disabled={currentQuestionIndex===(questionsAndPollsList.length-1)  || questionStage === 'scan'} onClick={()=>{playQuestionInSet(questionsAndPollsList[currentQuestionIndex+1])}} className={'syncLiveView-player-main-controlBar-questionControlBtn ' + (fadeOutQuestionControlButtons ? ' syncLiveView-player-main-controlBar-questionControlBtn--fade ' : '') + (fadeInQuestionControlButtons ? ' syncLiveView-player-main-controlBar-questionControlBtn--fadeIn ' : '')}>
								<div className='syncLiveView-player-main-controlBar-questionControlBtn-contents'>
									<svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
		  							<path d="M21.7097273,14.72 L3.37481818,1.52266667 C1.91881818,0.501333333 0.725,1.25066667 0.725,3.18933333 L0.725,28.8133333 C0.725,30.7466667 1.91881818,31.496 3.37481818,30.48 L21.7097273,17.2773333 C21.7097273,17.2773333 22.4199091,16.7466667 22.4199091,16.0026667 C22.4199091,15.256 21.7097273,14.72 21.7097273,14.72 Z M26.1795455,0 L28.725,0 C30.1326364,0 31.2704545,0.128 31.2704545,1.6 L31.2704545,30.4 C31.2704545,31.872 30.1326364,32 28.725,32 L26.1795455,32 C24.7719091,32 23.6340909,31.872 23.6340909,30.4 L23.6340909,1.6 C23.6340909,0.128 24.7719091,0 26.1795455,0 Z" fillRule="nonzero"></path>    
									</svg>
								</div>

								<div className='syncLiveView-player-main-controlBar-questionControlBtn-keyboardTooltip'>
									Shift<span className='syncLiveView-player-main-controlBar-questionControlBtn-keyboardTooltip-lighten'>&nbsp;+</span> 
									<Icon name='key--arrowRight'/>
								</div>

								{currentQuestionIndex!==(questionsAndPollsList.length-1) && !classSafeMode && questionsAndPollsList[currentQuestionIndex+1] &&
									<div className='syncLiveView-player-main-controlBar-questionControlBtn-slidePreviewContainer'>
										<StaticQuestionSlide question={questionsAndPollsList[currentQuestionIndex+1].questionSnapshot} stage='ask' mode='view' displayWidth={280} previewCard={true} />
									
									</div>
								}
							</button>
						}

						</div>						
				</div>
						
				
			)
 
	}
}


export default SyncLiveViewPlayerControlBar

